<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab active>
                <template slot="title">
                    <i class="fa fa-user mr-2"></i>{{Core.Definition.getDefinition('Profil')}}
                </template>
                <DynamicForm
                        v-model="dataId"
                        ref="dynamicForm"
                        getRoot="/user"
                        saveRoot="/user"
                        @onTrashClick="onTrashClick"
                        :formStructure="dataFormStructures.user">
                </DynamicForm>
                <ModalTrash
                        ref="trash"
                        root="/user"
                        @onTrashSuccess="onTrashSuccess"
                        :caption="Core.Definition.getDefinition('Suppression de l\'utilisateur')"
                        :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cet utilisateur?')"></ModalTrash>
            </b-tab>
            <b-tab v-if="Core.Validation.isId(dataId)&&Core.Session.AuthUser.can('order_management_get')">
                <template slot="title">
                    <i class="fa fa-shopping-cart mr-2"></i>{{Core.Definition.getDefinition('Commandes')}}
                </template>
                <b-row class="mb-2">
                    <b-col>
                        <b-button v-if="Core.Session.AuthUser.can('order_management_post')" @click="addOrder" class="btn btn-edit pull-right">{{Core.Definition.getDefinition('Nouvelle commande')}}</b-button>
                    </b-col>
                </b-row>
                <OrderList
                        :key="'order' + dataId"
                        :searchArgs="[
                        {
                            key: 'userId',
                            value: dataId
                        }
                    ]"></OrderList>
            </b-tab>
            <b-tab v-if="Core.Validation.isId(dataId)&&Core.Session.AuthUser.can('subscription_management_get')">
                <template slot="title">
                    <i class="fa fa-refresh mr-2"></i>{{Core.Definition.getDefinition('Abonnements récurrents')}}
                </template>
                <b-row class="mb-2">
                    <b-col>
                        <b-button v-if="Core.Session.AuthUser.can('subscription_management_post')" @click="addRecurring" class="btn btn-edit pull-right">{{Core.Definition.getDefinition('Nouvel abon. récurrent')}}</b-button>
                    </b-col>
                </b-row>
                <RecurringSubscriptionList
                        :key="'recurringSubscription' + dataId"
                        :searchArgs="[
                        {
                            key: 'userId',
                            value: dataId
                        }
                    ]"></RecurringSubscriptionList>
            </b-tab>
            <b-tab v-if="Core.Validation.isId(dataId)&&Core.Session.AuthUser.can('subscription_management_get')">
                <template slot="title">
                    <i class="fa fa-sort-numeric-desc mr-2"></i>{{Core.Definition.getDefinition('Abonnements limités')}}
                </template>
                <b-row class="mb-2">
                    <b-col>
                        <b-button v-if="Core.Session.AuthUser.can('subscription_management_post')" @click="addLimited" class="btn btn-edit pull-right">{{Core.Definition.getDefinition('Nouvel abon. limité')}}</b-button>
                    </b-col>
                </b-row>
                <LimitedSubscriptionList
                        :key="'limitedSubscription' + dataId"
                        :searchArgs="[
                        {
                            key: 'userId',
                            value: dataId
                        }
                    ]"></LimitedSubscriptionList>
            </b-tab>
            <b-tab v-if="Core.Validation.isId(dataId)">
                <template slot="title">
                    <i class="fa fa-check mr-2"></i>{{Core.Definition.getDefinition('Réservations')}}
                </template>
                <EventDateBookingList
                        :key="'bookings' + dataId"
                        :searchArgs="[
                        {
                            key: 'userId',
                            value: dataId
                        },
                        {
                            key: 'start',
                            value: Core.Date.getToday()
                        }
                    ]"></EventDateBookingList>
            </b-tab>
            <b-tab v-if="Core.Validation.isId(dataId)">
                <template slot="title">
                    <i class="fa fa-users mr-2"></i>{{Core.Definition.getDefinition('Utilisateurs associés')}}
                </template>
                <UserList
                        :key="'user' + dataId"
                        :caption="Core.Definition.getDefinition('Liste des utilisateurs enfants')"
                        :parentId="dataId"
                        :searchArgs="[
                        {
                            key: 'parentId',
                            value: dataId
                        }
                    ]"></UserList>
            </b-tab>
            <b-tab v-if="Core.Validation.isId(dataId)">
                <template slot="title">
                    <i class="fa fa-cogs mr-2"></i>{{Core.Definition.getDefinition('Paramètres')}}
                </template>
                <div class="p-2">
                <router-view></router-view>
                </div>
            </b-tab>
        </b-tabs>
        <ModalTrash
                ref="trash"
                root="/user"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'utilisateur')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cet utilisateur?')"></ModalTrash>
    </div>
</template>

<script>
    import Vue from 'vue'
    import DynamicForm from '../../components/DynamicForm'
    import OrderList from './OrderList'
    import ModalTrash from '../../components/ModalTrash'
    import RecurringSubscriptionList from './RecurringSubscriptionList'
    import LimitedSubscriptionList from './LimitedSubscriptionList'
    import UserList from '../../views/UserList'
    import EventDateBookingList from './EventDateBookingList'
    export default {
        name: 'User',
        components: {
            LimitedSubscriptionList,
            RecurringSubscriptionList,
            EventDateBookingList,
            DynamicForm,
            OrderList,
            ModalTrash,
            UserList
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    user: {
                        rows: [
                            {
                                cols: [
                                    {
                                        class: 'card-columns',
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Général'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'firstname'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'lastname'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'birthDate'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'lang'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'phone'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'mobile'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'email'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'parentId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Coordonnées'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'address'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'country'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'province'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'city'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'zipcode'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title1'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingAddress'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingCountry'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingProvince'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingCity'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingZipcode'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Notes'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'notes'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Authentification'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'branchId'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'role'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                show: Core.Value.encode(Core.Session.Setting.getSetting('event.leagueIsEnabled'), 'checkbox'),
                                                                fields: [
                                                                    {
                                                                        id: 'leagueId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'password'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'avatar'
                                                                    }
                                                                ]
                                                            },
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Identification'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'identityScan'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'parentId',
                                type: 'instanceSelector',
                                label: Core.Definition.getDefinition('Associer à un parent'),
                                value: {
                                    id: '',
                                    label: ''
                                },
                                emptyMessage: Core.Definition.getDefinition('Aucun parent sélectionné'),
                                instanceSelector: {
                                    label: [
                                        'firstname',
                                        'lastname'
                                    ],
                                    id: 'id',
                                    root: '/user/list',
                                    searchFormStructure: {
                                        rows: [
                                            {
                                                cols: [
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'firstname'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'lastname'
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                cols: [
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'email'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'phone'
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                cols: [
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'id'
                                                            }
                                                        ]
                                                    },
                                                    {}
                                                ]
                                            }
                                        ],
                                        fields: [
                                            {
                                                id: 'id',
                                                type: 'number',
                                                label: Core.Definition.getDefinition('ID'),
                                                value: ''
                                            },
                                            {
                                                id: 'firstname',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Prénom'),
                                                value: ''
                                            },
                                            {
                                                id: 'lastname',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Nom de famille'),
                                                value: ''
                                            },
                                            {
                                                id: 'phone',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Téléphone'),
                                                value: ''
                                            },
                                            {
                                                id: 'email',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Courriel'),
                                                value: ''
                                            }
                                        ]
                                    },
                                    options: {
                                        pagination: true,
                                        header: true,
                                        responsive: false,
                                        striped: true,
                                        headerStyle: '1',
                                        emptyText: Core.Definition.getDefinition('Aucun utilisateur à afficher'),
                                        borderVariant: 'white',
                                        noBody: true
                                    },
                                    columns: [
                                        {
                                            label: Core.Definition.getDefinition('#'),
                                            key: 'id',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Prénom'),
                                            key: 'firstname',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Nom'),
                                            key: 'lastname',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Courriel'),
                                            key: 'email',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Téléphone'),
                                            key: 'phone',
                                            sortable: true
                                        }
                                    ]
                                }
                            },
                            {
                                id: 'firstname',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Prénom'),
                                value: ''
                            },
                            {
                                id: 'email',
                                type: 'email',
                                label: Core.Definition.getDefinition('Courriel'),
                                value: ''
                            },
                            {
                                id: 'lastname',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Nom de famille'),
                                value: ''
                            },
                            {
                                id: 'identityScan',
                                type: 'scanText',
                                label: Core.Definition.getDefinition('Code d\'identification'),
                                value: ''
                            },
                            {
                                id: 'phone',
                                type: 'phone',
                                label: Core.Definition.getDefinition('Téléphone'),
                                value: ''
                            },
                            {
                                id: 'mobile',
                                type: 'phone',
                                label: Core.Definition.getDefinition('Mobile'),
                                value: ''
                            },
                            {
                                id: 'birthDate',
                                type: 'datePicker',
                                label: Core.Definition.getDefinition('Date de naissance'),
                                value: '',
                                onChange: function(value, form, fieldRefs) {}
                            },
                            {
                                id: 'role',
                                type: 'select',
                                required: true,
                                label: Core.Definition.getDefinition('Rôle'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'leagueId',
                                type: 'select',
                                required: false,
                                label: Core.Definition.getDefinition('Ligue'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'branchId',
                                type: 'select',
                                required: true,
                                invalidFeedbackMessage: Core.Definition.getDefinition('Vous devez sélectionner une établissement par défaut.'),
                                label: Core.Definition.getDefinition('Établissement par défaut'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'lang',
                                type: 'select',
                                required: true,
                                label: Core.Definition.getDefinition('Langue'),
                                value: {value: 'fr-CA', label :'Français'},
                                onSelect: function() {}
                            },
                            {
                                id: 'address',
                                type: 'text',
                                label: Core.Definition.getDefinition('Adresse'),
                            },
                            {
                                id: 'country',
                                type: 'country',
                                label: Core.Definition.getDefinition('Pays'),
                                required: false,
                                value: {value: 'CA', label :'Canada'},
                                onSelect: function(value, form, fieldRefs) {
                                    if (value !== null && value.value !== undefined) {
                                        fieldRefs['province'].retrieve(value.value)
                                    } else {
                                        fieldRefs['province'].dataValue = null
                                    }
                                }
                            },
                            {
                                id: 'province',
                                type: 'province',
                                value: {value: 'QC', label :'Quebec'},
                                label: Core.Definition.getDefinition('Province'),
                                required: false,
                                onSelect: function() {}
                            },
                            {
                                id: 'city',
                                type: 'text',
                                label: Core.Definition.getDefinition('Ville'),
                            },
                            {
                                id: 'zipcode',
                                type: 'text',
                                label: Core.Definition.getDefinition('Code Postal'),
                            },
                            {
                                id: 'billingAddress',
                                type: 'text',
                                label: Core.Definition.getDefinition('Adresse'),
                            },
                            {
                                id: 'billingCountry',
                                type: 'country',
                                label: Core.Definition.getDefinition('Pays'),
                                required: false,
                                value: {value: 'CA', label :'Canada'},
                                onSelect: function(value, form, fieldRefs) {
                                    if (value !== null && value.value !== undefined) {
                                        fieldRefs['billingProvince'].retrieve(value.value)
                                    } else {
                                        fieldRefs['billingProvince'].dataValue = null
                                    }
                                }
                            },
                            {
                                id: 'billingProvince',
                                type: 'province',
                                value: {value: 'QC', label :'Quebec'},
                                label: Core.Definition.getDefinition('Province'),
                                required: false
                            },
                            {
                                id: 'billingCity',
                                type: 'text',
                                label: Core.Definition.getDefinition('Ville'),
                            },
                            {
                                id: 'billingZipcode',
                                type: 'text',
                                label: Core.Definition.getDefinition('Code Postal'),
                            },
                            {
                                id: 'notes',
                                type: 'notes'
                            },
                            {
                                id: 'avatar',
                                type: 'avatar',
                                label: Core.Definition.getDefinition('Photo')
                            },
                            {
                                id: 'password',
                                type: 'password',
                                autoGenerateOption: true,
                                readable: true,
                                label: Core.Definition.getDefinition('Mot de passe')
                            },
                            {
                                id: 'title1',
                                type: 'title',
                                tag: 'h6',
                                label: Core.Definition.getDefinition('Informations de facturation')
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/systeme/utilisateurs')
            },
            addOrder() {
                this.$router.push(Core.Text.format(Core.Definition.getDefinition('/commerce/commandes/nouvelle-commande/{0}'), this.dataId))
            },
            addRecurring() {
                this.$router.push(Core.Text.format(Core.Definition.getDefinition('/commerce/abonnements-recurrents/nouvel-abonnement/{0}'), this.dataId))
            },
            addLimited() {
                this.$router.push(Core.Text.format(Core.Definition.getDefinition('/commerce/abonnements-limites/nouvel-abonnement/{0}'), this.dataId))
            }
        }
    }
</script>
